<template>
  <div class="Message xi">
    <nh-com></nh-com>
    <div class="personal-content">
      <div class="personal-box clearfix">
        <div class="personal-left">
          <hd-img :active="15"></hd-img>
        </div>
        <div class="personal-right">
          <div class="content">
            <div class="flex-start">
              <div class="line-title"></div>
              <div class="pageTitle">我的好友</div>
            </div>
            <!-- <div class="personal-right-tit">
              <ul class="tab-tit">
                <li v-for="(title, index) in tabTitle" @click="(cur = index), tabClick(title)" :class="{ active: index == cur }">{{ title.name }}</li>
              </ul>
              <el-link type="danger" :underline="false" class="el-icon-delete" @click="deleteAll"></el-link>
            </div> -->
            <!--    内容    -->
            <div style="margin-top: 10px">
              <el-table :data="tableData" :header-cell-style="{ background: '#F5F5F5' }" v-if="tableData.length > 0">
                <el-table-column label="编号" type="index" width="60px"></el-table-column>
                <el-table-column prop="name" label="好友列表">
                  <template slot-scope="scope">
                    <div class="flex-start">
                      <img style="width: 40px; height: 40px; margin-right: 5px" src="../../assets/img/userInfo/heard.png" />
                      <div>
                        <p>
                          <span style="font-size: 12px; margin-right: 5px">{{ scope.row.name }}</span>
                          <span style="background: #00c4ac; border-radius: 10px; color: #ffffff; font-size: 10px; padding: 4px 8px">{{ scope.row.versionName }}</span>
                        </p>
                        <p>{{ scope.row.phone }}</p>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="childernCount" label="邀请人数" align="center" width="80px">
                  <template slot-scope="scope">
                    <el-link type="primary" @click="prviewBtn(scope.row)" v-if="scope.row.childernCount > 0">{{ scope.row.childernCount }}</el-link>
                    <span v-else>{{ scope.row.childernCount }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="totalRevenue" label="贡献总收益（元）" align="center">
                  <template slot-scope="scope">
                    <p style="color: #e8200f">{{ scope.row.totalRevenue }}</p>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="110" align="center">
                  <template slot-scope="scope">
                    <el-link type="primary" @click="toDetail('./FriendChild', scope.row.userId)">收益详情<i class="el-icon-arrow-right"></i></el-link>
                    <!-- <p style="cursor: pointer" @click="toDetail('./FriendChild', scope.row.userId)">收益详情</p> -->
                  </template>
                </el-table-column>
              </el-table>
              <el-empty :image-size="115" v-else></el-empty>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="infoDialog" width="35%">
      <el-table :data="usersData" stripe style="width: 100%" height="440px">
        <el-table-column label="编号" type="index" width="60px"></el-table-column>
        <el-table-column prop="name" label="邀请列表">
          <template slot-scope="scope">
            <div class="flex-start">
              <img style="width: 40px; height: 40px; margin-right: 5px" src="../../assets/img/userInfo/heard.png" />
              <div>
                <p>
                  <span style="font-size: 12px; margin-right: 5px">{{ scope.row.name }}</span>
                  <span style="background: #00c4ac; border-radius: 10px; color: #ffffff; font-size: 10px; padding: 4px 8px">{{ scope.row.versionName }}</span>
                </p>
                <p>{{ scope.row.phone }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="totalRevenue" label="贡献总收益（元）" align="center">
          <template slot-scope="scope">
            <p style="color: #e8200f">{{ scope.row.totalRevenue }}</p>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <ft-com></ft-com>
  </div>
</template>

<script>
import ftCom from "../../components/footer";
import nhCom from "../../components/navheader";
import hdImg from "../../components/headerImg";
import { converName } from "../../utils/extend";
import { UserInfo } from "../../components/User/UserInfo";
import { clickName } from "../../utils/relation";
export default {
  components: {
    ftCom,
    nhCom,
    hdImg,
  },
  data() {
    var userInfo = new UserInfo(this.TokenClient, this.Services.Authorization);
    return {
      tableData: [],
      false: false,
      UserInfoDomain: userInfo,
      usersData: [],
      infoDialog: false,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      var _this = this;
      _this.tableData = [];
      _this.UserInfoDomain.ChildrenDistributors(
        function (data) {
          _this.tableData = data.data;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    prviewBtn(item) {
      var _this = this;
      this.usersData = [];
      _this.UserInfoDomain.SubordinateDistributors(
        item.userId,
        function (data) {
          _this.infoDialog = true;
          _this.usersData = data.data;
        },
        function (err) {
          console.log(err);
        }
      );
    },
    toDetail(path, id) {
      this.$router.push({
        path: path,
        query: {
          userId: id,
        },
      });
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/footer.css";

/**/
.personal-content {
  background: #f7f7f7;
  padding: 40px 0;
}

.personal-box {
  width: 1200px;
  margin: 0 auto;
}

.personal-left {
  float: left;
}

.personal-right {
  float: right;
  width: 985px;
  min-height: 740px;
  background: #ffffff;
  box-sizing: border-box;
}
.center-content {
  padding: 0 20px;
}
</style>
<style lang="scss" scoped>
.content {
  background: #fff;
  border-radius: 8px;
  padding: 20px 15px;
  min-height: 640px;
}
.line-title {
  width: 3px;
  height: 16px;
  background: #333;
  margin-right: 5px;
}
.pageTitle {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
}
.item {
  width: 23%;
  position: relative;
  margin-right: 2%;
  margin-bottom: 10px;
  .imgCove {
    width: 100%;
    height: 120px;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100%);
    border-radius: 6px;
  }
  .time {
    font-size: 12px;
    color: #999999;
  }
  .isCharge {
    position: absolute;
    top: 0;
    right: 10px;
    background: #ff7f44;
    border-radius: 0px 0px 4px 4px;
    z-index: 1;
    font-size: 12px;
    color: #fff;
    padding: 0 5px;
  }
  .isNoCharge {
    background: #16b2ac;
  }
  .desc {
    width: 90%;
    position: absolute;
    top: 95px;
    right: 5%;
    z-index: 1;
    color: #fff;
  }
}
.item:nth-child(4) {
  margin-right: 0;
}
.list {
  background: #f2f2f2;
  border-radius: 6px;
  padding: 5px 10px;
  margin-bottom: 10px;
}
</style>
<style>
.center-content .el-table .cell {
  cursor: pointer !important;
}

.el-table::before {
  height: 0;
}

.el-table td,
.el-table th.is-leaf {
  border-bottom: 1px dashed #ebeef5;
}
</style>
